exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "form[data-v-56934914]{background:#fff;padding:25px;border-radius:20px;overflow:auto}.form-bottom[data-v-56934914],.form-top[data-v-56934914]{margin:20px 0}#inscriptionType[data-v-56934914]{max-width:80px}.footer[data-v-56934914]{width:100%;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between}#confirm[data-v-56934914]{float:right}#confirm[data-v-56934914]:disabled{cursor:not-allowed}.header[data-v-56934914]{margin-bottom:50px}.logo[data-v-56934914]{height:60px;float:right;margin-bottom:10px}.brand .invalid[data-v-56934914] .multiselect__tags{border-color:red}.general-conditions[data-v-56934914]{margin-bottom:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-56934914","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/home/Charging.vue
// module id = 765
// module chunks = 0